<template>
  <div
    @contextmenu.prevent
    class="container"
    :style="{ display: !loading && !error ? 'block' : 'flex' }"
  >
    <div v-if="loading">
      <div>
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div>
        <strong>Chargement du document...</strong>
      </div>
    </div>
    <div v-else-if="error">
      <strong>Impossible de charger le fichier PDF</strong>
      <p>{{ error }}</p>
    </div>
    <vue-pdf-app
      v-else-if="pdfSrc"
      :key="fileId"
      ref="viewer"
      theme="light"
      :pdf="pdfSrc"
      :config="config"
    ></vue-pdf-app>
    <iframe
      v-else-if="videoSrc"
      style="width: 100%; height: 100%"
      :src="`${videoSrc}?rel=0&modestbranding=1&iv_load_policy=3`"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  components: {
    VuePdfApp,
  },
  data() {
    return {
      pdfSrc: null,
      videoSrc: null,
      loading: false,
      error: null,
      config: {
        sidebar: {
          viewThumbnail: true,
          viewOutline: true,
          viewAttachments: true,
        },
        secondaryToolbar: {
          secondaryPresentationMode: true,
          secondaryOpenFile: true,
          secondaryPrint: true,
          secondaryDownload: true,
          secondaryViewBookmark: true,
          firstPage: true,
          lastPage: true,
          pageRotateCw: true,
          pageRotateCcw: true,
          cursorSelectTool: true,
          cursorHandTool: true,
          scrollVertical: true,
          scrollHorizontal: true,
          scrollWrapped: true,
          spreadNone: true,
          spreadOdd: true,
          spreadEven: true,
          documentProperties: true,
        },
        toolbar: {
          toolbarViewerLeft: {
            findbar: true,
            previous: true,
            next: true,
            pageNumber: true,
          },
          toolbarViewerRight: {
            presentationMode: true,
            openFile: false,
            print: false,
            download: false,
            viewBookmark: false,
          },
          toolbarViewerMiddle: {
            zoomOut: true,
            zoomIn: true,
            scaleSelectContainer: true,
          },
        },
        errorWrapper: true,
      },
    };
  },
  mounted() {
    window.addEventListener("keydown", this.blockSaveShortcut);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.blockSaveShortcut);
  },
  methods: {
    async openFile(fileId) {
      this.loading = true;
      this.error = null;
      this.pdfSrc = null;
      this.videoSrc = null;
      this.fileId = fileId;
      try {
        const response = await this.$store.dispatch("leodata/getFile", fileId);
        if (response.file.type != "youtube") {
          const byteArray = Uint8Array.from(atob(response.pdfBase64), (c) =>
            c.charCodeAt(0)
          );
          const blob = new Blob([byteArray], { type: "application/pdf" });
          this.pdfSrc = URL.createObjectURL(blob);
        } else {
          this.videoSrc = response.file.link;
          console.log(response.file);
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
      } catch (error) {
        console.error("Erreur de chargement du fichier PDF :", error);
        this.error =
          error.message || "Erreur inconnue lors du chargement du PDF";
      } finally {
        this.loading = false;
      }
    },
    blockSaveShortcut(e) {
      if (
        (e.ctrlKey || e.metaKey) &&
        ["s", "p", "u", "c"].includes(e.key.toLowerCase())
      ) {
        e.stopImmediatePropagation();
      }
    },
  },
};
</script>
<style scoped>
.container {
  align-items: center;
  justify-content: center;
  text-align: center;
}
.container strong {
  font-size: 2em;
}
</style>
